import styled from '@emotion/styled';

import { PrimaryButton } from '@/components/common/Button/style';

export const Container = styled.div`
	display: flex;
	flex-direction: column;
	align-items: center;
	gap: ${(props) => props.theme.scale.space2xl};
	width: 100%;
	padding: ${(props) => props.theme.scale.space3xl} ${(props) => props.theme.scale.spaceLg};
	text-align: center;
`;

export const IconWrap = styled.div`
	display: flex;
	align-items: center;
	justify-content: center;
	width: 5.6rem;
	height: 5.6rem;
	border-radius: 50%;
	background: ${(props) => props.theme.colors.primary50};
	color: ${(props) => props.theme.colors.primary400};
	font-size: 2.4rem;
	font-weight: ${(props) => props.theme.fontWeight.weightBold};
`;

export const Title = styled.h2`
	margin: 0;
	font-size: ${(props) => props.theme.fontSize.size2xl};
	font-weight: ${(props) => props.theme.fontWeight.weightBold};
	color: ${(props) => props.theme.ui.text.primary};
	line-height: 1.3;
`;

export const Description = styled.p`
	margin: 0;
	max-width: 36rem;
	font-size: ${(props) => props.theme.fontSize.sizeMd};
	line-height: 1.6;
	color: ${(props) => props.theme.ui.text.secondary};
`;

export const HomeButton = styled(PrimaryButton)`
	min-width: 16rem;
`;
